import getCookie from "../partials/cookie";

const getLawyer = async (method, handleErrors) => {
    let errors = [];
    const response = await fetch('/api/lawyer_profiles_extended/current/');
    const data = await response.json();
    if(!response.ok) {
        response.json().then(data => {
            errors = Object.values(data)
            handleErrors(errors)
        })
    }
    method(data);
}

const getProblems = async (method, api_categories, count, loading, setErrors) => {
        let errors = [];
        const response = await fetch(`/api/problems/?category=${api_categories}&forum=true&not-responded=true&page=${count}`, {credentials: 'include'});
        if(!response.ok) {
            response.json().then(data => {
                    errors = data.non_field_errors
                            setErrors(errors)
        })}
        const data = await response.json();
        loading(false);
        method(data);
    }

const getCategories = async (method, setErrors) => {
       let errors = [];
        const response = await fetch(`/api/categories/`);
        if(!response.ok) {
            response.json().then(data => {
                    errors = data.non_field_errors
                            setErrors(errors)
        })}
        const data = await response.json();
        const sorted_categories = {
            'prywatne': [],
            'firmowe': []
        }
        data.map(item => {
            if(item.type === 1) {
                return sorted_categories.prywatne.push(item)
            } else {
                return sorted_categories.firmowe.push(item)
            }
        })
        method(sorted_categories);
} 

const changePage = async (method, api_categories, count, loading, setIndexCounter, setPage, option, setErrors) => {    
        let errors = [];
        let page = null;
        let sign = null;
        if (option === 'next') {
            page = count+1
            sign = 1
        } else {
            page = count-1
            sign = -1
        }
        const response = await fetch(`/api/problems/?category=${api_categories}&forum=true&not-responded=true&page=${page}`, {credentials: 'include'});
        if(!response.ok) {
            response.json().then(data => {
                    errors = data.non_field_errors
                        setErrors(errors)
                })
        }
        const data = await response.json();
        method(data);
        setIndexCounter(prevCount=> prevCount+1*sign);
        setPage(prevCount=> prevCount+1*sign)
        loading(false);
    }

const getNewsCenter = async (method, page_size, option, setLoading, categories, unread, searched, setErrors) => {
        let category_string = '';
        let was_read = '';
        let search_text = '';
        if(categories) {
            categories.map(item => {
                return category_string += `category=${item}&`
            })
        } else {
            categories = '&'
        }
        if(unread) {
            was_read = `&was_read_by_lawyer=${!unread}`
        }
        if(searched) {
            search_text = `&search=${searched}`
        }
        const response = await fetch(`/api/news-center-problem-list/?page=1&page_size=${page_size}&${option}=1${search_text}${was_read}&${category_string}`);
        if(!response.ok) {
            response.json().then(data => {
                    setErrors(['Nie udało się załadować problemów'])
                    
                })
        } else {
            setErrors([]);
        }
        const data = await response.json();
        method({[option]: data});
        setLoading(false)
    }

const getNavlinks = async (method, loading) => {
        const response = await fetch('/api/navbar-links/', {
            credentials: 'include'
        });
        if(!response.ok) {
            response.json().then(data => {
                    console.log(data)
                })
        }
        const data = await response.json();
        method(data);
        loading(false)
    }

const sendMessage =  async (message, problem_id, setErrors, setProblems, api_categories, count, loading, index_counter, setIndex, problems_count, setCurrentPage) => {
        let errors = [];
        var csrftoken = getCookie('csrftoken');
        await fetch((`/api/problems/${problem_id}/forum_response/`),{
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                'message': message,
                'created': new Date().toLocaleTimeString,

            })
        }).then(res => {
            if (!res.ok) {
                    res.json().then(
                        data => {
                            errors = data.message
                            setErrors(errors)
                        }
                    )
            } else {
                getProblems(setProblems, api_categories, count, loading)
                if(index_counter === problems_count) {
                    if([index_counter-1]%5 === 0) {
                        changePage(setProblems, api_categories, count, loading, setIndex, setCurrentPage, 'prev');
                    } else {
                        setIndex(prevCount => prevCount-1)
                    }
                }
                setErrors([])
            }
        })
    }

const generativeModelResponse =  async (problem_id, element_id, setLoading) => {
    var csrftoken = getCookie('csrftoken');
    fetch(`/api/problems/${problem_id}/generative_model_response/`, {
        method: 'POST',
        headers: {
            "X-CSRFToken": csrftoken
        }
    })
    .then(res => {
        res.json()
        .then(data => {
            setLoading(false);
            let element = document.getElementById(`${element_id}`);
            element.value = data.response;
            //console.log(element.value);
            element.style.height = 'inherit';
            element.style.height = `${element.scrollHeight}px`;
            console.log(element.value);
        });
    });
}

const changeIfRead = async (active, id, forum, read, update) =>  {
    var csrftoken = getCookie('csrftoken');
    await fetch((`/api/news-center-problem-list/${id}/change_problem_read/`),{
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            "X-CSRFToken": csrftoken
        },
        body: JSON.stringify({
            'forum': forum,
            'id': id,
            'read': !read
        })
    }).then(
        res => {
            if (res.ok) {
                if(active === 0) 
                update()
            } else {
                res.json().then(
                    data => console.log(data)
                )
            }
    })
}

const getDates =  async(id, data, handleEarliestDate, handleStartDate, handleData, displayedMonth, setErrors) => {
    await fetch(`/api/problems/${id}/response/`).then(res => res.json().then(
        d => {
            handleData(d)
            let current_month = new Date().getMonth()
            if (data.discount) {
                if(d.earliest_available_date){
                    handleEarliestDate(d.earliest_available_date);
                    handleStartDate(d.earliest_available_date)
                } else if (displayedMonth === current_month){
                    handleStartDate(new Date())
                    handleEarliestDate(new Date())                        
                } else {
                    handleEarliestDate(null)
                }
            }
            if (!res.ok) {
            res.json().then(
                data => {
                    let errors = []
                    errors = data.non_field_errors
                    setErrors(errors)
                }
            )
        }
        }
    ))
}

const sendModalRespond = async (problemId, earliest_available_date, message, setErrors, setIfSent, data) => {
    var csrftoken = getCookie('csrftoken');
            await fetch((`/api/problems/${problemId}/response/`),{
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                ...data,
                created: new Date(),
                earliest_available_date: earliest_available_date?new Date(Date.parse(earliest_available_date + 'EDT')).toISOString().slice(0,10):new Date().toISOString().slice(0,10),
                message: message,
                problem: problemId,
            })
        }).then(res => {
            if (!res.ok) {
                    res.json().then(
                        data => {
                            let local_errors = Object.values(data)
                            setErrors(local_errors)
                        }
                    )
            } else {
                setIfSent(true)
            }
        })
}

const getLatestAnswers = async (method,page, loading, default_category) => {
     let category_param = ''
    if (default_category) {
        category_param = `category=${default_category}&`
    }
    const response = await fetch(`/api/articles/?${category_param}&limit=${page*3}&page=${page}`, {
            credentials: 'include'
        });
        if(!response.ok) {
            response.json().then(data => {
                    console.log(data)
                    loading(false)
                })
        }
        const data = await response.json();
        method(data.results);
        loading(false)
}

const getLatestFreeQuestions = async (method, latest_problems, page, loading, default_category) => {
    let category_param = ''
    if (default_category) {
        category_param = `category=${default_category}&`
    }
    const response = await fetch(`/api/problems/?${category_param}forum=true&limit=5&page=${page}`, {
            credentials: 'include'
        });
        if(!response.ok) {
            response.json().then(data => {
                    console.log(data)
                    loading(false)
                })
        }
        const data = await response.json();
        if (page ===1) {
            method(data.results)
        } else if (Math.ceil(data.count/5) >= page) {
            method(latest_problems => [...latest_problems, ...data.results]
                    )}
        loading(false)
}


export {getLawyer, getCategories, changePage, getProblems, getNavlinks, sendMessage, generativeModelResponse, getNewsCenter, changeIfRead, getDates, sendModalRespond, getLatestAnswers, getLatestFreeQuestions};
